import { render, staticRenderFns } from "./CitybusFlexibusComponent.vue?vue&type=template&id=030998d8&"
import script from "./CitybusFlexibusComponent.vue?vue&type=script&lang=js&"
export * from "./CitybusFlexibusComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports